import { IIAMEntity } from "./iam-entity";

export interface IIAMAttachedPolicy extends Pick<IIAMEntity, "id"> {
  PolicyName?: string;
  PolicyArn?: string;
}

export interface IIAMPolicy extends IIAMEntity {
  PolicyName?: string;

  PolicyId?: string;

  DefaultVersionId?: string;

  AttachmentCount?: number;

  PermissionsBoundaryUsageCount?: number;

  IsAttachable?: boolean;

  Description?: string;

  UpdateDate?: Date;

  Tags?: Tag[];
}

export enum IAMPolicyType {
  Managed = "Managed",
  Custom = "Custom",
  Inline = "Inline",
}

export interface IIAMPolicyVersion {
  Document?: string;
  VersionId?: string;
  IsDefaultVersion?: boolean;
  CreateDate?: Date;
  Type: IAMPolicyType;
}

export interface IIAMPolicyVersionRequest {
  PolicyArn: string;
  VersionId?: string;
}

export interface Tag {
  Key?: string;
  Value?: string;
}

export interface IIAMPolicyCreateRequest {
  PolicyName: string;

  PolicyDocument: string;

  Description?: string;
}

export interface IIAMPolicyUpdateRequest
  extends
    Omit<IIAMPolicyCreateRequest, "PolicyName">,
    Required<Pick<IIAMAttachedPolicy, "PolicyArn">> {}

export enum IAMPolicySortField {
  PolicyName = "PolicyName",
  ARN = "Arn",
  CreateDate = "CreateDate",
  LastUsed = "PasswordLastUsed",
  AttachmentCount = "AttachmentCount",
}
